import { render, staticRenderFns } from "./GeneralInfoReport.vue?vue&type=template&id=192315da&scoped=true"
import script from "./GeneralInfoReport.vue?vue&type=script&lang=js"
export * from "./GeneralInfoReport.vue?vue&type=script&lang=js"
import style0 from "./GeneralInfoReport.vue?vue&type=style&index=0&id=192315da&prod&scoped=true&lang=css"
import style1 from "./GeneralInfoReport.vue?vue&type=style&index=1&id=192315da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192315da",
  null
  
)

export default component.exports